

import { lazy } from 'react';
import './globals.css';
import './Test2.css';
import './Text.css';
import './Test.css';
import Nav from './Nav/Nav.js';
import Footer from './Footer/Footer.js';
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';
import Offre from './Offre/Offre.js';
import Contact from './Contact/Contact.js';
import Methode from './Rdv/Methode.js';
import Coach from './Coach/Coach.js';
import HomeBlog from './Blog/home_blog.js';
import Contactconfirm from './Contactconfirm.js';
import Blog from './Blog/view_blog.js';
import MethodePage from "./Methode/Methode_page.js";
import Rdvconfirm from './Rdvconfirm.js';
import "./Offre/Offre.css";
import "./Homepage/homepage.css";
import Home from "./Homepage/Home.js";
import Home2 from "./Homepage/Home2.js";
import Home3 from "./Homepage/Home3.js";
import Schema from "./Schema/Schema.js";
import Temoignages from "./Homepage/Temoignages.js";
import ClientLP from "./LP/ClientLP.js";


const MentionsLegales = lazy(() => import("./Mentions/Mentions_legales.js"));
const Cgv = lazy(() => import("./Mentions/Cgv.js"));
/*const Homepage = lazy(() => import("./Homepage/Homepage.js"));*/


function Test() 
{
  
  

  return (
    
    
    <div className="Test">
      <script src="https://kit.fontawesome.com/c298d004d1.js" crossorigin="anonymous"></script>
      
      

      
      
      <Switch>

     

      

      <Route path='/offre'>
      
      <Nav />
      <Offre />

      </Route>

      <Route path='/Methode_page'>
      
      <Nav />
      <MethodePage/>

      </Route>


      <Route path = '/LP/:url'   >

      <Nav />
      <ClientLP />

    </Route>
      

      <Route path='/rendez-vous'>
       <Nav />
      <br /><br /><br /><br /><br />

      <Methode/>

      </Route>

      <Route path='/confirmationrdv'>
      <Nav />
        <br /> <br /><br /><br /><br /><br /><br />
      
      <Rdvconfirm/>
      
      </Route>

      <Route path='/confirmationcontact'>
      <Nav />
        <br /> <br /><br /><br /><br /><br /><br />
      
      <Contactconfirm/>
      
      </Route>

      <Route path='/Cgv'>
      <Nav />
      <Cgv />

      </Route>

      <Route path='/Mentions'>
      <Nav />
      <MentionsLegales />

      </Route>


      <Route path='/contact'>
      <Nav />
      <Contact />

      </Route>

      <Route path='/coach'>
      <Nav />
      <Coach />

      </Route>

      <Route path='/blog/*'>
      <Nav />
      <Blog />

      </Route>

      

      <Route exact path='/blog'>
      <Nav />
      <HomeBlog />

      </Route>

      <Route exact path='/'>
      
      <Nav />
      <Home />
      <Home2 />
      <Home3 />
      <Schema />
      <Temoignages />
      

      </Route>

      </Switch>


      <Footer />
      
    </div>
    
  );
}

export default Test;
